export default {
  PRODUCTSLISTSPOS(state) {
    return state.productsListsPos;
  },
}